import React from 'react';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="customer-footer">
      <div className="customer-footer__inner">
        <p className="customer-footer__company">VGP Promoters Private Limited</p>
        <p className="customer-footer__address">
          Plot No.25, Jagajeevaram Avenue, Injambakkam, Sholinganallur, Chennai, India, 600115
        </p>
      </div>
    </footer>
  );
};

export default Footer;
